import { render, staticRenderFns } from "./agingStockDetail.vue?vue&type=template&id=db20c5a4&scoped=true"
import script from "./agingStockDetail.vue?vue&type=script&lang=js"
export * from "./agingStockDetail.vue?vue&type=script&lang=js"
import style0 from "./agingStockDetail.vue?vue&type=style&index=0&id=db20c5a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db20c5a4",
  null
  
)

export default component.exports